import { render, staticRenderFns } from "./OrganizationUsersDeleteItem.vue?vue&type=template&id=0787256e&"
import script from "./OrganizationUsersDeleteItem.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUsersDeleteItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports